const axios = require('axios').default;
const RESOURCE_NAME = process.env.REACT_APP_LOG_API_BASE;

const getHeader = (token) => {
    if (!token) {
        token = localStorage.getItem("accessToken");
    }
    return {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
};

export default {
    log(level, category, message, stackTrace) {
        const requestOptions = {
            headers: getHeader(),
        };
        const bodyData = {
            level: level,
            category: category,
            mesg: message,
            stackTrace: stackTrace
        };
        //return axios.post(`${RESOURCE_NAME}/logs`, JSON.stringify(bodyData), requestOptions);
    }
}
